import { render, staticRenderFns } from "./move_file.vue?vue&type=template&id=3423b995&scoped=true&"
import script from "./move_file.vue?vue&type=script&lang=js&"
export * from "./move_file.vue?vue&type=script&lang=js&"
import style0 from "./move_file.vue?vue&type=style&index=0&id=3423b995&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3423b995",
  null
  
)

export default component.exports